<template>
  <div class="">
    <header-view></header-view>
    <main>
      <router-view></router-view>
    </main>
    <!--/main-->
    <footer-view></footer-view>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderView from './header.vue'
import FooterView from './footer.vue'

export default {
  name: 'layoutTemplate',
  components: {
    HeaderView,
    FooterView
  }
}
</script>
